import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type Toast = {
  title?: string;
  type: string;
  caption?: string;
};
type State = {
  toasts: Toast[];
};

type Actions = {
  addToast: (toast: Toast) => void;
  addSingleToast: (toast: Toast) => void;
  removeFirst: () => void;
  removeToast: (toast: Toast) => void;
  removeAll: () => void;
};

export const useToasterStore = create(
  immer<State & Actions>((set) => ({
    toasts: [],
    addToast: (toast) => {
      set((state) => ({ toasts: [...state.toasts, toast] }));
      setTimeout(() => {
        set((state) => ({ toasts: state.toasts.slice(1) }));
      }, 6000);
    },
    addSingleToast: (toast) => {
      set(() => ({ toasts: [toast] }));
      setTimeout(() => {
        set(() => ({ toasts: [] }));
      }, 6000);
    },
    removeFirst: () => set((state) => ({ toasts: state.toasts.slice(1) })),
    removeToast: (toast) => set((state) => ({
      toasts: state.toasts.filter((_t) => _t.title !== toast.title),
    })),
    removeAll: () => set({ toasts: [] }),
  })),
);
